import { SxProps } from '@mui/material'
import { inputClasses } from '@/components/Inputs/Input/Input.data'
import { COLORS, FONT_WEIGHTS } from '@/styles'

export interface FooterStyleType {
  subscribeWrapper: SxProps
  inputWrapperStyle: SxProps
  subscribeButton: SxProps
  subscribeButtonFanatics: SxProps
  input: SxProps
  inputLabel: SxProps
  wrapper: SxProps
  socialWrapper: SxProps
  socialBrandWrapper: SxProps
  socialSubHeading: SxProps
  socialImageWrapper: SxProps
  socialIcons: SxProps
  socialIcon: SxProps
  brandLogo: SxProps
  linkCategoryTitle: SxProps
  linkSection: SxProps
  linkCategory: SxProps
  privacyLink: SxProps
  copyRightLink: SxProps
  copyRightLinks: SxProps
  copyRightSection: SxProps
  copyRightText: SxProps
  linkListWrapper: SxProps
  linkText: SxProps
  divider: SxProps
}

export const footerStyles: FooterStyleType = {
  wrapper: {
    backgroundColor: 'primary.smokyBlack',
    pt: {
      xs: 7.5,
      md: 10,
    },
    px: {
      xs: 2.5,
      md: 5,
    },
  },
  socialWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: { xs: 'column', lg: 'row' },
    gap: {
      xs: 3,
      lg: 0,
    },
  },
  socialBrandWrapper: {
    flexDirection: 'column',
    display: 'flex',
    gap: 2.5,
    pb: 1,
  },
  socialSubHeading: {
    typography: {
      xs: 'textXlMedium',
      md: 'displayXs',
    },
    fontWeight: {
      md: FONT_WEIGHTS.HEAVY,
    },
    color: 'text.primaryWarmIvory',
  },
  socialImageWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 2,
  },
  socialIcons: {
    width: 25,
    height: 25,
    '& path': { fill: `${COLORS.WARM_IVORY}!important` },
  },
  socialIcon: {},
  brandLogo: {
    width: { xs: 146, md: 240 },
    color: 'text.primaryWarmIvory',
  },
  linkCategoryTitle: {
    typography: 'textSmBold',
    fontWeight: {
      xs: FONT_WEIGHTS.SEMI_BOLD,
      lg: FONT_WEIGHTS.STRONG,
    },
    color: 'text.primaryWarmIvory',
    textTransform: 'uppercase',
    letterSpacing: '.84px',
  },
  linkSection: {
    display: 'flex',
    pt: 10,
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  linkCategory: {
    flexDirection: 'column',
    display: 'flex',
    pb: 5,
    pr: 3,
    width: { xs: '100%', md: '50%', lg: '33.3%', xl: '20%' },
    color: 'text.primaryWarmIvory',
    gap: 2.5,
  },
  copyRightLink: {
    color: 'text.primaryWarmIvory',
    typography: 'textXs',
    pb: { xs: 3, sm: 0 },
  },
  copyRightLinks: {
    gap: { xs: 0, sm: 5 },
    display: { xs: 'contents', sm: 'flex' },
  },
  privacyLink: {
    color: 'text.primaryWarmIvory',
    typography: 'textXs',
    pr: 5,
    display: { xs: 'flow', sm: 'inline' },
    pb: 3,
  },
  copyRightSection: {
    pt: 5,
    pb: {
      xs: 4,
      md: 0,
    },
    display: { xs: 'flow', sm: 'flex' },
    justifyContent: 'space-between',
  },
  copyRightText: {
    typography: 'textXs',
    color: 'text.primaryWarmIvory',
    display: { xs: 'flow', sm: 'flex' },
    pb: 3,
  },
  linkListWrapper: {
    flexDirection: 'column',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    gap: {
      xs: 2.5,
      md: 1.5,
    },
  },
  linkText: {
    typography: 'textSm',
    color: 'text.primaryWarmIvory',
  },
  divider: { borderColor: 'utils.gray600', m: 0 },
  input: {
    color: 'utils.gray400',
  },
  inputLabel: {
    typography: 'textSm',
    color: 'utils.gray400',
  },
  subscribeButton: {
    width: { xs: '100%', md: 'fit-content' },
  },
  subscribeButtonFanatics: {
    width: { xs: '100%', md: 'fit-content' },
    bgcolor: 'text.primaryWarmIvory',
    borderColor: 'text.primaryWarmIvory',
  },
  inputWrapperStyle: {
    [`.${inputClasses.state.focused} &`]: {
      borderColor: 'button.borderSecondary',
      outlineColor: 'button.borderSecondary',
    },
    maxWidth: '100%',
  },
  subscribeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    width: { md: 400, xl: 500 },
  },
}
